<script>

  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';

  export let amount, futureAmount, currency, settings;

  let cvc, date, number = '', cvcField;

  export const onAmountChange = () => {
  };

  export const getPaymentDetails = async (billingInfo) => {
    return new Promise((resolve, reject) => {
      let dateParts = date.split('/');
      let month = dateParts[0].trim();
      let year = External.WebPlatform.parse(dateParts.length > 1 ? dateParts[1].trim() : '', 2018);
      if (year < 100) {
        year += 2000;
      }
      number = number.trim();

      let cardData = {
        authData: {
          clientKey: settings.publicKey,
          apiLoginID: settings.apiLoginId
        },
        cardData: {
          cardNumber: number,
          month: month,
          year: year,
          cardCode: cvc.trim()
        }
      };
      External.CPanel.disableUI(true);
      window.Accept.dispatchData(cardData, function(response) {
        External.CPanel.enableUI();
        if (response.messages.resultCode === 'Error') {
          let message = Array.isArray(response.messages.message) ? response.messages.message[0].text : (response.messages.message?.text || response.messages.message?.text);
          External.Log.error('Error auhtorizing payment with Authorize.net:');
          External.Log.error(response.messages);
          External.CPanel.showError(message);
          reject(message);
        } else {
          resolve({
            nonce: JSON.stringify(response.opaqueData),
            cardType: 'card',
            lastTwo: number.length > 1 ? number.substring(number.length - 2, number.length) : ''
          });
        }
      });
    });
  };

  let verifyCvc = () => {
    let validCvc = cvc.replace(/[^0-9]/g, '').substring(0, 4);
    if (validCvc !== cvc) {
      cvc = validCvc;
    }
  };

  let onDateChange = (event) => {
    if ((event.which || event.keyCode) === 9)
      return false;

    let value = date.replace(/[^0-9]/g, '');
    if (value.length > 4)
      value = value.substring(0, 4);
    let suffix = value.length > 2 ? value.substring(2) : '';
    if (value.length > 1) {
      value = value.substring(0, 2) + ' / ' + suffix;
    }
    if (value !== date) {
      date = value;
    }
    if (value.length === 7) {
      cvcField.focus();
    }
  };

  let setup = async () => {
  };

  let teardown = () => {
  };

  onMount(() => {
    External.WebPlatform.requestScripts([{
      script: 'https://' + (settings.inSandbox ? 'jstest' : 'js') + '.authorize.net/v1/Accept.js',
      check: () => !!window.Accept
    }], setup);
  });

  onDestroy(teardown);
</script>

<div class="payment-info">
  <div class="col20 f-left card-form">
    <h4>{M.CRED_CARD_INFO}</h4>
    <div class="col20 f-left card-fields-single-line flex flex-row mt-15">
      <input type="text" class="input-field card-number flex-one" placeholder="{M.CARD_NUMBER}" bind:value={number} />
      <input type="text" placeholder="MM / YY" class="input-field card-date" bind:value={date} on:keyup={(event) => onDateChange(event)} />
      <input type="text" placeholder="CVC" class="input-field card-cvc" bind:this={cvcField} bind:value={cvc} on:input={verifyCvc} />
    </div>
  </div>
</div>
